import React from 'react'
import Card from '@material-ui/core/Card'
import Typography from '@material-ui/core/Typography'

import styles from '../../chartTooltip/styles'

import { withStyles } from '@material-ui/core/styles'

const valueIsEmpty = value =>
  typeof value === 'object' ?
    _.isEmpty(value)
    : value == undefined

const dataIsNotEmpty = data =>
  !!data && !_.isEmpty(data) && data.some(line => !_.isEmpty(line.payload[line.name]))

const getLastElements = (array = [], numberOfElements) => {
  if (array.length < numberOfElements) return array

  return _.takeRight(array, numberOfElements)
}

const EventsMapTooltip = ({ classes = {}, active, payload, dateVisualization }) => {
  if (active && dataIsNotEmpty(payload)) {
    const firstPoint = payload[0]
    const headerText = dateVisualization ? firstPoint.payload.date : firstPoint.payload.dap

    return <div className={classes.ChartTooltip}>
      <Typography variant='body2'>{I18n.t('v4/irrigation_system.events.title')} - {headerText}</Typography>
      {
        payload.map(line =>
          !valueIsEmpty(line.payload[line.name])
            ? <div key={line.name}>
              <span className={classes.PointData}>
              <Typography variant='body1'>{I18n.t(`v4/irrigation_system.events.${line.name}`)}</Typography>
              <span className={classes.PointData__value}>
                {
                  Array.isArray(line.payload[line.name])
                    ? <div>
                      {
                        getLastElements(line.payload[line.name], 3).map((data, index) =>
                          <Typography variant='body2' key={`${data}-${index}`} align='right'>
                            {typeof data === 'object' && data.title ? 
                              <div style={{maxWidth: '300px', wordWrap: 'break-word', overflowWrap: 'break-word'}}>
                                <strong>{data.title}</strong>
                                {data.description && (
                                  <div style={{
                                    fontSize: '0.85em', 
                                    opacity: 0.8, 
                                    marginTop: '4px',
                                    lineHeight: '1.3',
                                    maxHeight: '60px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 3,
                                    WebkitBoxOrient: 'vertical'
                                  }}>
                                    {data.description}
                                  </div>
                                )}
                              </div>
                              : String(data)
                            }
                          </Typography>
                        )
                      }
                    </div>
                    : <>
                      <Typography variant='body2'>
                        {String(line.payload[line.name])}
                      </Typography>
                    </>
                }
              </span>
              </span>
              {
                Array.isArray(line.payload[`${line.name}_history`]) &&
                  line.payload[`${line.name}_history`].map((change, index) =>
                    <Typography
                      key={`${line.name}-history-${index}`}
                      variant='caption'
                      component='div'
                      style={{ opacity: 0.72, textAlign: 'right', maxWidth: '300px' }}
                    >
                      {change}
                    </Typography>
                  )
              }
            </div>
            : null
        )
      }
    </div>
  }
  return null
}

export default withStyles(styles)(EventsMapTooltip)
